module.exports = __webpack_public_path__ + "img/menu_s_2.122829fe.png";